<template>
  <form @submit.prevent="">
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="row custom-header">
          <div class="col">
            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="col-1">
            <a href="#" class="custom-close" @click="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </template>
      <template #body>
        <div class="custom-body">
          <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
          <div v-if="currentTab === 'Basic'" class="row p-3 custom-form">
            <matrix-basic :value="modelValue" @changed="isHighlight = true" />
          </div>
          <div v-if="currentTab === 'Sub-Categories'" class="row p-3 custom-form">
            <div class="row">
              <div class="col-md-12">
                <p>Supply those decoded sub-category items (from the decoder as "item") you wish to associate with this ADAS merge category.</p>
              </div>
              <div class="col-md-12">
                <matrix-categories :matrix="adasmatrix" :is-read-only="false" @changed="isHighlight = true" />
              </div>
            </div>
          </div>
          <div v-if="currentTab === 'Highlight'" class="row p-3 custom-form">
            <matrix-highlight :value="modelValue" @changed="isHighlight = true" />
          </div>
          <div v-if="currentTab === 'Hints'" class="row p-3 custom-form">
            <matrix-hints :value="modelValue" @changed="isHighlight = true" />
          </div>
          <div v-if="currentTab === 'Makes'" class="row p-3 custom-form">
            <matrix-makes :value="modelValue" @changed="isHighlight = true" />
          </div>
          <div v-if="currentTab === 'Info'" class="row p-3 custom-form">
            <matrix-info :source="2" :value="modelValue" @changed="isHighlight = true" />
          </div>
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col-2">
            <span>{{ id }}</span>
          </div>
          <div class="col">
            <z-message v-model="message" class="alert alert-warning mt-2" />
          </div>
          <div class="col-3 custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button class="btn btn-primary ms-2" :class="{ 'btn-danger': isHighlight }" @click="save">Save</button>
          </div>
        </div>
      </template>
    </z-dialog>
  </form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZMessage from '@/components/utilities/elements/Message.vue'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import MatrixBasic from './matrix-basic.vue'
import MatrixHighlight from './matrix-highlight.vue'
import MatrixHints from './matrix-hints.vue'
import MatrixCategories from './matrix-categories.vue'
import MatrixMakes from './matrix-makes.vue'
import MatrixInfo from './matrix-info.vue'
export default {
  name: 'DialogMatrix',
  components: {
    ZDialog,
    ZMessage,
    ZTabs,
    MatrixBasic,
    MatrixHighlight,
    MatrixHints,
    MatrixCategories,
    MatrixMakes,
    MatrixInfo
  },
  props: {
    modelValue: Object
  },
  data() {
    return {
      modalSize: 'modal-lg',
      message: '',
      isHighlight: false,
      currentTab: 'Basic'
    }
  },
  emits: ['input', 'closing', 'saved'],
  computed: {
    ...mapState(adasmatrixStore, ['adasmatrix']),
    isVisible() {
      return this.modelValue !== null
    },
    tabs() {
      let _tabs = ['Basic']
      if (!this.isAdd) {
        _tabs.push('Sub-Categories')
        _tabs.push('Highlight')
        _tabs.push('Hints')
        _tabs.push('Info')
        _tabs.push('Makes')
      }
      return _tabs
    },
    id() {
      let _data = null
      if (this.adasmatrix !== undefined && this.adasmatrix !== null) {
        if (this.adasmatrix.adasChecklistMatrix !== null) {
          _data = `# ${this.adasmatrix.adasChecklistMatrix}`
        }
      }
      return _data
    },
    title() {
      let _title = ''
      let _item = ''
      if (this.modelValue) {
        if (this.adasmatrix !== undefined && this.adasmatrix !== null) {
          _item = this.adasmatrix.matrixItem
        }
        if (this.modelValue.type === 'ADD') {
          _title = 'Adding Merge Category'
        } else {
          _title = `Editing ${_item}`
        }
      }
      return _title
    },
    isAdd() {
      let _is = false
      if (this.modelValue) {
        _is = this.modelValue.type === 'ADD'
      }
      return _is
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['saveAdasMatrix']),
    close() {
      this.isHighlight = false
      this.currentTab = 'Basic'
      this.$emit('closing')
    },
    showTab(value) {
      console.log('Changing tab', value)
      this.currentTab = value
    },
    submit() {},
    async save() {
      let valid = true
      this.message = ''
      if (this.adasmatrix.matrixItem === null || this.adasmatrix.matrixItem === '') {
        valid = false
        this.message = 'Please fill in the Category.'
      }
      if (valid) {
        console.log('saving ADAS Matrix', this.adasmatrix)
        this.isSave = false
        let id = await this.saveAdasMatrix(this.adasmatrix)
        this.isHighlight = false
        this.currentTab = 'Basic'
        this.$emit('saved', {
          id: id,
          isAdd: this.isAdd
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  color: #000;
  cursor: pointer;
}
.custom-body {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 600px;
  min-height: 450px;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
</style>
